<style lang="scss">




@media screen and (min-width: 55rem) {
  .target-container {
    width: 100%;
    margin-top: 5rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .target {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;

      .target-title {
        font-size: 24px;
        font-family:  'PingFang SC','Microsoft YaHei';
        font-weight: 400;
        color: #e5004f;
      }
      .target-subtitle {
        font-size: 8px;
        font-family:  'PingFang SC','Microsoft YaHei';
        font-weight: 500;
        color: #7d7d7d;
        line-height: 28px;
        text-transform: uppercase;
      }
      .block {
        margin-top: 1rem;
        width: 43px;
        height: 4px;
        background: #e5004f;
      }
      .video {
        margin-top: 2rem;
        width: 100%;
        height: 600px;
      }
    }
  }
}
@media screen and (max-width: 55rem) {
  .target-container {
    width: 100%;
    margin-top: 5rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .target {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;

      .target-title {
        font-size: 24px;
        font-family:  'PingFang SC','Microsoft YaHei';
        font-weight: 400;
        color: #e5004f;
      }
      .target-subtitle {
        font-size: 8px;
        font-family:  'PingFang SC','Microsoft YaHei';
        font-weight: 500;
        color: #7d7d7d;
        line-height: 28px;
        text-transform: uppercase;
      }
      .block {
        margin-top: 1rem;
        margin-bottom: 2rem;
        width: 43px;
        height: 4px;
        background: #e5004f;
      }
      .video {
        width: 100%;
        height: 232px;
      }
    }
  }
}
</style>

<template>
  <div class="target-container">
    <div class="target">
      <div class="target-title">银泰百货介绍</div>
      <div class="target-subtitle">Intime Introduction</div>
      <div class="block"></div>
      <!-- <video
        src="https://intime-web2021.oss-cn-shanghai.aliyuncs.com/1641488441755-%E9%93%B6%E6%B3%B0%E6%96%B0%E9%9B%B6%E5%94%AE%E5%AE%A3%E4%BC%A0%E7%89%870824%20%E9%93%B6%E6%B3%B020%E5%91%A8%E5%B9%B4LOGO.mov"
        controls="controls"
        class="video"
      ></video> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "title",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
